import { useQuery } from '@tanstack/vue-query';
import { computed, Ref } from 'vue';

import personApi from '~/services/person-api/person-api';

export default function usePartner(partnerId: Ref<number>) {
  return useQuery({
    enabled: computed(() => !!partnerId.value && partnerId.value > 0),
    queryFn: () => personApi.partner.getById({
      partner_id: partnerId.value,
      with_sfplus: true,
    }),
    queryKey: computed(() => ['partner', partnerId.value]),
    retry: 3,
  });
}
